import { FC, memo } from 'react';

import { type SpacingComponentProps } from '@hh.ru/magritte-ui-spacing/types';
import { genCssVarsFromSizesMap, getSizesMap } from '@hh.ru/magritte-ui-spacing/utils';

import styles from './styles.less';

export const VSpacing: FC<SpacingComponentProps> = memo((spacingSizes) => {
    const cssVars = genCssVarsFromSizesMap(getSizesMap(spacingSizes));

    return <div className={styles.vSpacing} style={cssVars} />;
});

VSpacing.displayName = 'VSpacing';
